/**
 * KATSEYE Photo Cards — flip, drag-and-drop, z-stacking, confetti, mobile carousel
 */
(function () {
  'use strict';

  var topZ = 50;
  var hasConfettiFired = false;

  function initCardSections() {
    var sections = document.querySelectorAll('.katseye-cards');
    sections.forEach(function (section) {
      initDesktopArena(section);
      initMobileCarousel(section);
    });
  }

  /* --------------------------------------------------------------------------
     Desktop Arena — scatter, drag, flip, stack
     -------------------------------------------------------------------------- */
  function initDesktopArena(section) {
    var arena = section.querySelector('[data-card-arena]');
    if (!arena) return;

    var cards = arena.querySelectorAll('.katseye-card');
    if (!cards.length) return;

    var enableScatter = section.dataset.scatter === 'true';
    var enableConfetti = section.dataset.confetti === 'true';

    // Apply scatter jitter (if enabled) without overwriting CSS calc() positions
    if (enableScatter) {
      applyScatter(cards, section);
    }

    cards.forEach(function (card) {
      card._rotation = parseFloat(card.dataset.initialRotation) || 0;
      initDrag(card, arena);
    });
  }

  function applyScatter(cards, section) {
    var mobileCarouselOff = section && section.dataset.mobileCarousel === 'false';
    var ksUnit = Math.min(1, window.innerWidth / 1440);
    if (window.innerWidth < 750 && !mobileCarouselOff) {
      ksUnit = window.innerWidth / 375;
    }

    cards.forEach(function (card) {
      var rotation = parseFloat(card.dataset.initialRotation) || 0;
      var jitterX = (Math.random() - 0.5) * 40 * ksUnit;
      var jitterY = (Math.random() - 0.5) * 30 * ksUnit;
      rotation += (Math.random() - 0.5) * 8;

      // Apply scatter as additional translate on top of the existing CSS transform
      card.style.transform = 'translate(calc(-50% + ' + jitterX + 'px), calc(-50% + ' + jitterY + 'px)) rotate(' + rotation + 'deg)';
      card._rotation = rotation;
    });
  }

  /* --------------------------------------------------------------------------
     Drag, Drop & Corner Rotation (desktop only)
     -------------------------------------------------------------------------- */
  var CORNER_ZONE = 24; // px from corner to trigger rotation mode

  function isNearCorner(e, cardRect) {
    var x = e.clientX - cardRect.left;
    var y = e.clientY - cardRect.top;
    var w = cardRect.width;
    var h = cardRect.height;

    return (
      (x < CORNER_ZONE && y < CORNER_ZONE) ||
      (x > w - CORNER_ZONE && y < CORNER_ZONE) ||
      (x < CORNER_ZONE && y > h - CORNER_ZONE) ||
      (x > w - CORNER_ZONE && y > h - CORNER_ZONE)
    );
  }

  function initDrag(card, arena) {
    var isActive = false;
    var hasMoved = false;
    var hasConverted = false;
    var mode = 'none'; // 'drag' | 'rotate' | 'none'
    var offsetX, offsetY, startClientX, startClientY;
    var rotateStartAngle, rotateStartRotation;

    // Show rotation cursor when hovering near corners
    card.addEventListener('mousemove', function (e) {
      if (isActive) return;
      var rect = card.getBoundingClientRect();
      card.style.cursor = isNearCorner(e, rect) ? 'alias' : 'grab';
    });

    card.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;

      isActive = true;
      hasMoved = false;
      hasConverted = false;

      // Bring to front
      topZ++;
      card.style.zIndex = topZ;

      var cardRect = card.getBoundingClientRect();
      startClientX = e.clientX;
      startClientY = e.clientY;

      // Decide mode based on click location
      if (isNearCorner(e, cardRect)) {
        mode = 'rotate';
        var centerX = cardRect.left + cardRect.width / 2;
        var centerY = cardRect.top + cardRect.height / 2;
        rotateStartAngle = Math.atan2(e.clientY - centerY, e.clientX - centerX);
        rotateStartRotation = card._rotation || 0;
      } else {
        mode = 'drag';
        offsetX = e.clientX - cardRect.left;
        offsetY = e.clientY - cardRect.top;
      }

      card.setPointerCapture(e.pointerId);
      e.preventDefault();
    });

    card.addEventListener('pointermove', function (e) {
      if (!isActive) return;

      // Check if moved enough to count as intentional
      if (!hasMoved) {
        var dx = Math.abs(e.clientX - startClientX);
        var dy = Math.abs(e.clientY - startClientY);
        if (dx > 4 || dy > 4) {
          hasMoved = true;
        } else {
          return;
        }
      }

      if (mode === 'rotate') {
        // Rotate around card center
        var cardRect = card.getBoundingClientRect();
        var centerX = cardRect.left + cardRect.width / 2;
        var centerY = cardRect.top + cardRect.height / 2;
        var currentAngle = Math.atan2(e.clientY - centerY, e.clientX - centerX);
        var delta = (currentAngle - rotateStartAngle) * (180 / Math.PI);
        var newRotation = rotateStartRotation + delta;

        card._rotation = newRotation;

        // Apply rotation, preserving existing translate if present
        var currentTransform = card.style.transform || '';
        if (currentTransform.indexOf('translate') !== -1) {
          card.style.transform = currentTransform.replace(/rotate\([^)]*\)/, 'rotate(' + newRotation + 'deg)');
        } else {
          card.style.transform = 'rotate(' + newRotation + 'deg)';
        }

        card.classList.add('is-dragging');

      } else if (mode === 'drag') {
        // Convert from CSS calc() to pixel positioning on first drag move
        if (!hasConverted) {
          hasConverted = true;
          card.classList.add('is-dragging');

          var cardRect = card.getBoundingClientRect();
          var arenaRect = arena.getBoundingClientRect();
          card.style.left = (cardRect.left - arenaRect.left) + 'px';
          card.style.top = (cardRect.top - arenaRect.top) + 'px';
          card.style.transform = 'rotate(' + (card._rotation || 0) + 'deg)';
        }

        var arenaRect = arena.getBoundingClientRect();
        var x = e.clientX - arenaRect.left - offsetX;
        var y = e.clientY - arenaRect.top - offsetY;

        var cardW = card.offsetWidth;
        var cardH = card.offsetHeight;
        x = Math.max(-cardW * 0.3, Math.min(arenaRect.width - cardW * 0.7, x));
        y = Math.max(-cardH * 0.2, Math.min(arenaRect.height - cardH * 0.7, y));

        card.style.left = x + 'px';
        card.style.top = y + 'px';
      }
    });

    card.addEventListener('pointerup', function (e) {
      if (!isActive) return;
      isActive = false;
      card.classList.remove('is-dragging');
      card.style.cursor = 'grab';

      // If user didn't drag or rotate, treat as click → flip
      if (!hasMoved) {
        toggleFlip(card, card.closest('.katseye-cards').dataset.confetti === 'true');
      }

      mode = 'none';
    });

    card.addEventListener('pointercancel', function () {
      isActive = false;
      card.classList.remove('is-dragging');
      card.style.cursor = 'grab';
      mode = 'none';
    });
  }

  /* --------------------------------------------------------------------------
     Flip
     -------------------------------------------------------------------------- */
  function initFlip(card, enableConfetti) {
    // Desktop flip is handled via pointerup (no-drag click)
    // Mobile gets tap handler below
  }

  function canFlip(card) {
    if (card.dataset.canFlip === 'false') return false;
    var section = card.closest('.katseye-cards');
    if (section && section.dataset.flip === 'false') return false;
    return true;
  }

  function toggleFlip(card, enableConfetti) {
    if (!canFlip(card)) return;

    var wasFlipped = card.classList.contains('is-flipped');
    card.classList.toggle('is-flipped');

    // Bring to front
    topZ++;
    card.style.zIndex = topZ;

    // Confetti on first flip ever
    if (!wasFlipped && enableConfetti && !hasConfettiFired) {
      hasConfettiFired = true;
      fireConfetti(card);
    }
  }

  /* --------------------------------------------------------------------------
     Confetti Burst
     -------------------------------------------------------------------------- */
  function fireConfetti(sourceEl) {
    var container = document.createElement('div');
    container.className = 'katseye-confetti';
    document.body.appendChild(container);

    var rect = sourceEl.getBoundingClientRect();
    var originX = rect.left + rect.width / 2;
    var originY = rect.top + rect.height / 2;

    var colors = ['#e84b8a', '#f4a0b8', '#ffffff', '#ff6b9d', '#ffd700', '#ff1493', '#ff69b4'];
    var shapes = ['circle', 'square', 'triangle'];

    for (var i = 0; i < 60; i++) {
      var piece = document.createElement('div');
      piece.className = 'katseye-confetti__piece';

      var color = colors[Math.floor(Math.random() * colors.length)];
      var shape = shapes[Math.floor(Math.random() * shapes.length)];
      var size = 6 + Math.random() * 10;

      piece.style.width = size + 'px';
      piece.style.height = size + 'px';
      piece.style.left = originX + (Math.random() - 0.5) * 200 + 'px';
      piece.style.top = originY + (Math.random() - 0.5) * 100 + 'px';

      if (shape === 'circle') {
        piece.style.borderRadius = '50%';
        piece.style.background = color;
      } else if (shape === 'square') {
        piece.style.background = color;
        piece.style.borderRadius = '2px';
      } else {
        piece.style.width = '0';
        piece.style.height = '0';
        piece.style.borderLeft = size / 2 + 'px solid transparent';
        piece.style.borderRight = size / 2 + 'px solid transparent';
        piece.style.borderBottom = size + 'px solid ' + color;
        piece.style.background = 'none';
      }

      var duration = 1 + Math.random() * 1.5;
      var delay = Math.random() * 0.3;
      piece.style.animation = 'katseye-confetti-fall ' + duration + 's ' + delay + 's ease-out forwards';

      container.appendChild(piece);
    }

    setTimeout(function () {
      container.remove();
    }, 3500);
  }

  /* --------------------------------------------------------------------------
     Mobile Carousel — center-focus with scale, looping, swipe
     -------------------------------------------------------------------------- */
  function initMobileCarousel(section) {
    if (section.dataset.mobileCarousel === 'false') return;

    var carousel = section.querySelector('[data-card-carousel]');
    if (!carousel) return;

    var cards = Array.prototype.slice.call(carousel.querySelectorAll('.katseye-card'));
    var dots = section.querySelectorAll('[data-dot-index]');
    var counter = section.querySelector('[data-card-counter]');
    var totalCards = cards.length;
    if (totalCards === 0) return;

    var currentIndex = 0;
    var isAnimating = false;
    var SWIPE_THRESHOLD = 40;
    var TRANSITION_MS = 400;

    // --- State management ---
    function mod(n, m) {
      return ((n % m) + m) % m;
    }

    function updateCarousel(direction) {
      var prevIdx = mod(currentIndex - 1, totalCards);
      var nextIdx = mod(currentIndex + 1, totalCards);

      cards.forEach(function (card, i) {
        var wasVisible =
          card.classList.contains('is-active') ||
          card.classList.contains('is-prev') ||
          card.classList.contains('is-next');

        card.classList.remove('is-active', 'is-prev', 'is-next');

        var targetClass = '';
        if (i === currentIndex) targetClass = 'is-active';
        else if (i === prevIdx) targetClass = 'is-prev';
        else if (i === nextIdx) targetClass = 'is-next';

        if (targetClass) {
          // Cards entering from hidden: snap into position without transition
          if (!wasVisible) {
            card.style.transition = 'none';
            card.classList.add(targetClass);
            card.offsetHeight; // force reflow
            card.style.transition = '';
          } else {
            card.classList.add(targetClass);
          }
        }

        // Reset flip on cards leaving active position
        if (i !== currentIndex) {
          card.classList.remove('is-flipped');
        }
      });

      // Update dots
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });

      // Update counter
      if (counter) {
        counter.textContent = (currentIndex + 1) + ' / ' + totalCards;
      }
    }

    function goTo(index) {
      if (isAnimating) return;
      isAnimating = true;
      currentIndex = mod(index, totalCards);
      updateCarousel();
      setTimeout(function () {
        isAnimating = false;
      }, TRANSITION_MS);
    }

    // --- Touch / swipe handling ---
    var touchStartX = 0;
    var touchStartY = 0;
    var touchDeltaX = 0;
    var isSwiping = false;

    carousel.addEventListener(
      'touchstart',
      function (e) {
        if (isAnimating) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchDeltaX = 0;
        isSwiping = false;
      },
      { passive: true }
    );

    carousel.addEventListener(
      'touchmove',
      function (e) {
        if (isAnimating) return;
        var dx = e.touches[0].clientX - touchStartX;
        var dy = e.touches[0].clientY - touchStartY;

        // Lock to horizontal once threshold met
        if (!isSwiping && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
          isSwiping = true;
        }

        if (isSwiping) {
          e.preventDefault();
          touchDeltaX = dx;
        }
      },
      { passive: false }
    );

    carousel.addEventListener('touchend', function () {
      if (isAnimating || !isSwiping) return;

      if (Math.abs(touchDeltaX) > SWIPE_THRESHOLD) {
        if (touchDeltaX < 0) {
          goTo(currentIndex + 1);
        } else {
          goTo(currentIndex - 1);
        }
      }
      isSwiping = false;
    });

    // --- Tap handling: flip center card, navigate on side cards ---
    cards.forEach(function (card) {
      var tapStartX = 0;
      var tapStartY = 0;

      card.addEventListener(
        'touchstart',
        function (e) {
          tapStartX = e.touches[0].clientX;
          tapStartY = e.touches[0].clientY;
        },
        { passive: true }
      );

      card.addEventListener('touchend', function (e) {
        // Only treat as tap if finger didn't move much
        var dx = Math.abs(e.changedTouches[0].clientX - tapStartX);
        var dy = Math.abs(e.changedTouches[0].clientY - tapStartY);
        if (dx > 10 || dy > 10) return;

        e.preventDefault();

        if (card.classList.contains('is-active')) {
          toggleFlip(card, section.dataset.confetti === 'true');
        } else if (card.classList.contains('is-prev')) {
          goTo(currentIndex - 1);
        } else if (card.classList.contains('is-next')) {
          goTo(currentIndex + 1);
        }
      });

      // Prevent click default on mobile to avoid double-firing
      card.addEventListener('click', function (e) {
        e.preventDefault();
      });
    });

    // --- Dot clicks ---
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.dataset.dotIndex, 10);
        goTo(index);
      });
    });

    // Set initial state
    updateCarousel();
  }

  /* --------------------------------------------------------------------------
     Init
     -------------------------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardSections);
  } else {
    initCardSections();
  }

  // Shopify theme editor re-init
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('.katseye-cards')) {
        initCardSections();
      }
    });
  }
})();
